import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSPagingButton } from '../paging-button/index.esm.js';
class EGDSPagingNextButton extends React.Component {
  static displayName = 'EGDSPagingNextButton';
  render() {
    return jsx(EGDSPagingButton, {
      ...this.props,
      icon: "chevron_right"
    });
  }
}
export { EGDSPagingNextButton };